import Vue from 'vue'
import Router from 'vue-router'
import welcome from '@/pages/welcome'
import login from '@/pages/login'
import peaMain from '@/pages/peaMain'
import peaPrint from '@/pages/peaPrint'
import createPEA from '@/pages/createPEA'
import clonePEAs from '@/pages/clonePeas'
import clonedPEA from '@/pages/clonedPEA'
import viewPEAApprovalRolesAndUsers from '@/pages/ViewPEAApprovalRolesAndUsers'
import updates from '@/pages/recentUpdates'

import advancedSearch from '@/pages/advancedSearch'
import advancedSearchTable from '@/components/advancedSearch/advancedSearchTable'
import advancedSearchFilter from '@/components/advancedSearch/advancedSearchFilter'

import adminArea from '@/pages/adminArea'
import changePEAOwner from '@/components/adminArea/changePEAOwner'

import PEAApprovalRolesAndRules from '@/components/adminArea/PEAApprovalRolesAndRules'
import peaChangeStatus from '@/components/adminArea/peaChangeStatus'
import changeApprovalRule from '@/components/adminArea/changeApprovalRule'
import createApprovalRule from '@/components/adminArea/createApprovalRule'
import createApprovalUserRole from '@/components/adminArea/createApprovalUserRole'
import selectApprovalUserRole from '@/components/adminArea/selectApprovalUserRole'
import adminPEAApprovalRolesAndUsers from '@/components/adminArea/PEAApprovalRolesAndUsers'
import adminDivisionAccess from '@/components/adminArea/adminDivisionAccess'

import changeApprovalUserRole from '@/components/adminArea/changeApprovalUserRole'
import changeNotificationListener from '@/components/adminArea/changeNotificationListener'
import adminViewPeaApproversByPEA from '@/components/adminArea/adminViewPeaApproversByPEA'
import peaChangeCheckNotifications from '@/components/adminArea/peaChangeCheckNotifications'
import adminViewPEANotificationsByUser from '@/components/adminArea/adminViewPEANotificationsByUser'
import adminPEANotificationListeners from '@/components/adminArea/PEANotificationListeners'
import viewAdminsByDivision from '@/components/adminArea/viewAdminsByDivision'

import peaAuthorization from '@/components/peaMain/peaAuthorization'
import myPeas from '@/pages/myPeas'
import allPeas from '@/pages/allPeas'
import myApprovals from '@/pages/myApprovals'

import standardGroupingReports from '@/pages/standardGroupingReports'
import customGroupingReports from '@/pages/customGroupingReports'
import report from '@/pages/report'
import store from '../state/store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '',
      name: 'Welcome',
      component: welcome
    },
    {
      path: '/login',
      name: 'Login',
      component: login
    },
    {
      path: '/editPea/:peaId?',
      name: 'PEA',
      component: peaMain,
      props: true
    },
    {
      path: '/printPea/:peaId?',
      name: 'Print PEA',
      component: peaPrint,
      props: true
    },
    {
      path: '/createPEA',
      name: 'createPEA',
      component: createPEA
    },
    {
      path: '/viewPEAApprovalRolesAndUsers',
      name: 'viewPEAApprovalRolesAndUsers',
      component: viewPEAApprovalRolesAndUsers
    },
    {
      path: '/clonedPEA/:peaId?',
      name: 'ClonedPEA',
      component: clonedPEA,
      props: true
    },
    {
      path: '/clonePEAs/status/:statusId?',
      name: 'CloneMyPEAs',
      component: clonePEAs,
      props: true
    },
    {
      path: '/search',
      component: advancedSearch,
      props: true,
      children: [
        {
          path: 'results',
          name: 'results',
          component: advancedSearchTable,
          props: true
        },
        {
          path: '/',
          name: 'advancedSearch',
          component: advancedSearchFilter,
          props: true
        }
      ]
    },
    {
      path: '/peaAuthorizations/:peaId?',
      name: 'PEAAuthorizations',
      component: peaAuthorization,
      props: true
    },
    {
      path: '/adminArea',
      name: 'AdminArea',
      component: adminArea,
      children: [
        {
          path: 'changeOwner',
          component: changePEAOwner
        },
        {
          path: 'PEAApprovalRolesAndRules',
          component: PEAApprovalRolesAndRules
        },
        {
          path: 'peaChangeStatus',
          component: peaChangeStatus
        },
        {
          path: 'adminDivisionAccess/:userName?',
          component: adminDivisionAccess,
          props: true
        },
        {
          path: 'adminViewPeaApproversByPEA',
          component: adminViewPeaApproversByPEA
        },
        {
          path: 'adminViewPEANotificationsByUser',
          component: adminViewPEANotificationsByUser
        },
        {
          path: 'changeApprovalRule/:ruleId',
          component: changeApprovalRule,
          props: true
        },
        {
          path: 'createApprovalRule',
          name: 'createApprovalRule',
          component: createApprovalRule
        },
        {
          path: 'createApprovalUserRole',
          name: 'createApprovalUserRole',
          component: createApprovalUserRole
        },
        {
          path: 'selectApprovalUserRole',
          name: 'selectApprovalUserRole/:userRoleId',
          component: selectApprovalUserRole
        },
        {
          path: 'peaApprovalRolesAndUsers',
          component: adminPEAApprovalRolesAndUsers
        },
        {
          path: 'changeApprovalUserRole/:userRoleId',
          component: changeApprovalUserRole,
          props: true
        },
        {
          path: 'peaChangeCheckNotifications',
          component: peaChangeCheckNotifications
        },
        {
          path: 'peaNotificationListeners',
          component: adminPEANotificationListeners
        },
        {
          path: 'changeNotificationListener/:NotificationId',
          component: changeNotificationListener,
          props: true
        },
        {
          path: 'viewAdminsByDivision',
          component: viewAdminsByDivision
        }
      ]
    },
    {
      path: '/my-peas/status/:statusId?',
      name: 'MyPEAs',
      component: myPeas,
      props: true
    },
    {
      path: '/all-peas/status/:statusId?',
      name: 'AllPEAs',
      component: allPeas,
      props: true
    },
    {
      path: '/my-approvals/:statusId?',
      name: 'MyApprovals',
      component: myApprovals,
      props: true
    },
    {
      path: '/reports/standard-grouping',
      name: 'Standard Grouping Reports',
      component: standardGroupingReports,
      props: true
    },
    {
      path: '/reports/custom-grouping',
      name: 'Custom Grouping Reports',
      component: customGroupingReports,
      props: true
    },
    {
      path: '/report/:query',
      name: 'Report',
      component: report,
      props: true
    },
    {
      path: '/updates',
      name: 'Updates',
      component: updates
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})

const setAccount = () => {
  const accounts = Vue.prototype.$msalInstance.getAllAccounts()
  if (accounts.length === 0) return false
  Vue.prototype.$msalInstance.setActiveAccount(accounts[0])
  store.state.userInfo.account = accounts[0]
  return true
}

function isTokenExpired (account) {
  if (!account) return true
  const tokenExpireTime = account.idTokenClaims.exp

  const currentTime = Math.floor(Date.now() / 1000)
  return tokenExpireTime < currentTime
}

router.beforeEach((to, from, next) => {
  setAccount()
  if (to.name === 'Login') {
    next()
    return
  }

  if (setAccount() === false || isTokenExpired(store.state.userInfo.account)) {
    next({
      path: '/login?unauthorized=1',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

export default router
